module.exports = __webpack_public_path__ + "img/L_TD.6f189ae8.png";